module.exports = __webpack_public_path__ + "static/media/Golurk_gaussian2.482b0968.png";